module.exports = __webpack_public_path__ + "static/media/cv.f9922e01.svg";